module.exports = __webpack_public_path__ + "static/NQA_ISO9001_BW-861adc132ba24fb8f3f7564f3ad1e727.svg";